import React from 'react'
import FooterIcon from '../Icons/FooterIcon'
import s from './Footer.module.scss'

const Footer = () => {
  return (
    <div className={s.footer}>
      <span className={s.footerLabel}>
        2021 &copy;
        <a href='http://paypos.tn/fr' target='_blank'>
          PAYPOS
        </a>{' '}
      </span>
    </div>
  )
}

export default Footer
